<template>
  <div>
    <LoadingProgress :show-loading="showLoading"></LoadingProgress>
  </div>
</template>

<script>
import LoadingProgress from '@/components/LoadingProgress'
import { mapGetters } from 'vuex'
export default {
  name: 'LoadingWithStore',
  data () {
    return {
      showLoading: this.isBandLoading
    }
  },
  components: { LoadingProgress },
  computed: {
    ...mapGetters([ 'isBandLoading' ])
  },
  watch: {
    isBandLoading (newVal) {
      this.showLoading = !!newVal
    }
  }
}
</script>
